import MarketBanner from "./MarketBanner";
import MarketListBlock from "./MarketListBlock";

function MarketPlace() {
  return (
    <>
      <MarketBanner />
      <MarketListBlock />
    </>
  );
}

export default MarketPlace;
